__turbopack_context__.v({
  "baseClass": "MH9gya_baseClass",
  "exclusive": "MH9gya_exclusive",
  "medium": "MH9gya_medium",
  "new": "MH9gya_new",
  "propertyBadge": "MH9gya_propertyBadge",
  "rentedOut": "MH9gya_rentedOut",
  "reserved": "MH9gya_reserved",
  "small": "MH9gya_small",
  "sold": "MH9gya_sold",
  "unlocked": "MH9gya_unlocked",
});
